import axios from 'axios'
import qs from 'qs'

const deleteMessage = (messageId, failureCallback, errorMessage) => {
  axios.post('/inbox/delete', qs.stringify({ messageId: messageId, yip_csrf_token: document.getElementById('csrftoken').value }))
    .then(() => {
      window.location.reload()
    })
    .catch(res => {
      if (res.response.status === 404) {
        window.location.reload()
      } else {
        failureCallback(errorMessage)
      }
    })
}

const DeletePrivateMessage = ({ messageId, errorCallback, phrases }) => (
  <div class='qa-private-message-delete' onClick={() => deleteMessage(messageId, errorCallback, phrases.errorMessage)}>
    { phrases.delete }
  </div>
)
export default DeletePrivateMessage
